module.exports = __webpack_public_path__ + "img/dealer_logo.e972e6c2.png";